import React from "react";

const Admin_server_port = () => {
  return (
    <div className="mx-2 my-2 card-body p-3 sm:p-4 rounded-xl border border-slate-200 bg-gradient-to-br from-sky-50 via-white to-rose-50 shadow-sm">
      <h2 className="text-2xl font-bold m-0 text-slate-800">Server Port</h2>
      <div className="mt-4 rounded-lg border border-slate-200 bg-white p-4 text-slate-600">
        Trang cấu hình server_port đang được nối route thành công.
      </div>
    </div>
  );
};

export default Admin_server_port;
